/** Formattazione condivisa web/API (locale italiano di default). */
export function formatMoney(cents: number | bigint, currency = "EUR", locale = "it-IT"): string {
  const v = Number(cents) / 100;
  return new Intl.NumberFormat(locale, { style: "currency", currency, useGrouping: "always" as never, maximumFractionDigits: Number.isInteger(v) ? 0 : 2 }).format(v);
}
export function formatHours(minutes: number): string {
  const h = minutes / 60;
  return `${Number.isInteger(h) ? h : h.toFixed(1)} h`;
}
export function toIsoDay(d: Date): string {
  return d.toISOString().slice(0, 10);
}
export function fromIsoDay(s: string): Date {
  return new Date(`${s}T00:00:00.000Z`);
}
export function addDays(s: string, n: number): string {
  return toIsoDay(new Date(fromIsoDay(s).getTime() + n * 86_400_000));
}
export function initials(first: string, last = ""): string {
  return `${first.trim()[0] ?? ""}${last.trim()[0] ?? ""}`.toUpperCase() || "?";
}
export function slugify(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60) || "spazio";
}
